import { PlessResponderSub } from '../../../../kymw00/pless-responder-sub.service';
import { MiddleClassCodeComboBoxModel } from '../middle-class-code-combo-box.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 中分類情報リストを取得する
 *
 * @export API通信成功時の処理
 * @class GetMiddleClassListService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetMiddleClassListService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: MiddleClassCodeComboBoxModel;
  private orderCode: string = <string>'';
  private classCode: string = <string>'';
  private largeClassCode: string = <string>'';
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetMiddleClassListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.orderCode,
        ClassCode: this.classCode,
        LargeClassCode: this.largeClassCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {MiddleClassCodeComboBoxModel} model
   * @param {string} orderCode
   * @param {string} classCode
   * @param {string} largeClassCode
   * @param {Function} [successFunc=null]
   * @memberof GetMiddleClassListService
   */
  execute(model: MiddleClassCodeComboBoxModel, orderCode: string, classCode: string, largeClassCode: string, successFunc: Function = null) {
    this.model = model;
    this.orderCode = orderCode;
    this.classCode = classCode;
    this.largeClassCode = largeClassCode;
    this.successFunc = successFunc;
    this.send('KYMW02getMiddleClassList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetMiddleClassListService
   */
  success(data: any) {
    this.model.updateMiddleClassList(data);
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }

}
